import React, { useState, Fragment, useMemo, useEffect } from 'react'
import styled from 'styled-components'
import { Col } from 'react-bootstrap'
import { replace } from 'lodash'
import { connect, useDispatch } from 'react-redux'
import moment from 'moment'

import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import { Image } from 'react-bootstrap'
import { Input } from './../../../../Components/Form/Input'
import { DateTimePicker } from './../../../../Components/Form/DateTimePicker'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import { Textarea } from './../../../../Components/Form/Textarea'
import SubmitButton from './../../../../Components/Form/SubmitButton'
import FormButton from './../../../../Components/Form/Button'
import { MissionMap } from './../../../../Components/Missions/MissionMap'
import { Section, SectionLabel, SectionRow } from 'Components/Section'
import ConfirmableTimePicker from './../../../../Components/Form/ConfirmableTimePicker'
import Form, { Checkbox } from './../../../../Components/Form'

import {
  enableUIBlock,
  disableUIBlock,
} from '../../../../Reducers/UIBlock/actions'
import { authorization } from './../../../../Module/Auth/Auth'
import { getBAName } from '../../../../Utils/User'
import { formatFieldValue } from '../../../../Utils/Formatters'
import {
  convertTimeToTimestamp,
  getEditableFields,
  getTimestampAndSetTime,
  isValidNumericValue,
  missionCheckinCheckoutTimeFormater,
} from './util'
import {
  number,
  maxValue,
  minValue,
  required,
} from 'Utils/Validators/formValidation'
import {
  BRAND_AMBASSADOR_STATUS_ENUM,
  CAMPAIGN_ENUM_TYPES,
  MISSION_ENUM_TYPES,
  MISSION_STATUS_ENUM,
  ROLE_ADMIN,
  ROLE_CITY_MANAGER,
} from '../../../../shared/constants'
import {
  isLocalDateStr,
  formatToLocalDate,
} from '../../../../shared/libraries/utils/date'
import { showReduxModal } from '../../../../Reducers/UI/actions'
import Availabilities from '../../../City/Page/Ambasadors/Availabilities'
import { handlingErrorContractAvailabilitiesPopup } from '../../../City/Page/Ambasadors/Availabilities/utils'
import NoShowBadge from '../../../../Components/Missions/NoShowBadge'
import { useNoShowLog } from '../../../Mission/hooks/useNoShowLog'
import {
  betweenNumbers,
  zeroRequired,
} from '../../../../Utils/Validators/formValidation'

const ProfilePicture = styled(Image)`
  width: auto;
  height: 235px;
`

let warningShow = {
  date: false,
  location: false,
  groupDate: false,
  groupLocation: false,
}

const EditMissionDetailsInner = props => {
  const {
    mission,
    city,
    history,
    campaign,
    match: { url },
  } = props

  const { user } = mission
  const { currencySign } = city
  // Used to update the map when you switch location
  const [location, setLocation] = useState(props.location)
  const [hasPayoutRatioValue, setHasPayoutRatioValue] = useState(
    mission.payoutRatio ? true : false,
  )
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false)
  const [isValidCheckInOutTime, setIsValidCheckInOutTime] = useState(true)
  const [payoutRatioError, setPayoutRatioError] = useState('')
  const [availabilities, setAvailabilities] = useState(null)
  const [contractWarning, setContractWarning] = useState(null)
  const [isContractWarningSkipped, setIsContractWarningSkipped] = useState(
    false,
  )
  const [week, setWeek] = useState(moment(mission.dateTime).isoWeek())
  const [dataForWarningFromForm, setDataForWarningFromForm] = useState({
    userId: mission.userId,
    dateTime: mission.dateTime,
  })
  const [isDataChanged, setIsDataChanged] = useState(false)
  const [isFirstRender, setIsFirstRender] = useState(true)
  const [isLoadedAvailabilities, setIsLoadedAvailabilities] = useState(false)
  const [
    isNeedRefetchavAilabilities,
    setIsNeedRefetchavAilabilities,
  ] = useState(false)
  const isGermany = mission.cityPlan.city.country.code === 'DE'
  const isAdmin = authorization.isAdmin()
  const canSeeBonusThreshold = [ROLE_ADMIN, ROLE_CITY_MANAGER].includes(
    authorization.getUser().role,
  )

  const { showBadge: showNoShowBadge } = useNoShowLog({
    mission,
  })
  const primaryMetric = mission.campaign.metrics.nodes
    ? mission.campaign.metrics.nodes.find(m => m.isPrimary)
    : null

  const locations = useMemo(() => {
    const filteredLocations = props.locations.reduce((acc, location) => {
      if (!location.isSelfServe) {
        acc.push(location)
      }
      return acc
    }, [])
    return location && location.isSelfServe
      ? [...filteredLocations, location]
      : [...filteredLocations]
  }, [])

  const dispatch = useDispatch()

  const shouldShowCurrentPosition =
    authorization.isSpy() ||
    authorization.isCityManager() ||
    authorization.isAdmin()

  const isEmployeeOrSpy =
    authorization.isAdmin() ||
    authorization.isSpy() ||
    authorization.isCityManager()

  if (mission.dateTime && !isLocalDateStr(mission.dateTime))
    throw new Error('Expects dateTime to be a local date.')

  if (mission.checkInTime && !isLocalDateStr(mission.checkInTime))
    throw new Error('Expects checkInTime to be a local date.')

  if (mission.checkoutTime && !isLocalDateStr(mission.checkoutTime))
    throw new Error('Expects checkoutTime to be a local date.')

  const handleCancel = () => {
    history.push(replace(url, '/edit', ''))
  }

  const updateMission = async form => {
    props.dispatch(enableUIBlock())

    //convert data from form to updateMission format
    const convertedFormData = Object.entries(form).reduce(
      (acc, [fieldName, { value }]) => {
        acc[fieldName] = value
        return acc
      },
      {},
    )

    try {
      const newData = {
        ...convertedFormData,
        id: mission.id,
        draftPayAdjustment: isValidNumericValue(
          convertedFormData.draftPayAdjustment,
        )
          ? Number(convertedFormData.draftPayAdjustment)
          : undefined,
        bonusOnConversion: isValidNumericValue(
          convertedFormData.bonusOnConversion,
        )
          ? Number(convertedFormData.bonusOnConversion)
          : undefined,
        payRatio: isValidNumericValue(convertedFormData.payRatio)
          ? Number(convertedFormData.payRatio)
          : undefined,
        checkoutFlyerQuantity: isValidNumericValue(
          convertedFormData.checkoutFlyerQuantity,
        )
          ? Number(convertedFormData.checkoutFlyerQuantity)
          : undefined,
        checkInTime:
          mission.checkInTime == convertedFormData.checkInTime
            ? undefined
            : missionCheckinCheckoutTimeFormater(
                mission.dateTime,
                convertedFormData.checkInTime,
              ),
        checkoutTime:
          mission.checkoutTime == convertedFormData.checkoutTime
            ? undefined
            : missionCheckinCheckoutTimeFormater(
                mission.dateTime,
                convertedFormData.checkoutTime,
              ),
        relatedCampaign: +campaign.id,
        payoutRatio: convertedFormData.payoutRatio
          ? replaceComma(convertedFormData.payoutRatio)
          : null,
        isNotShown: false,
        bonusThreshold: convertedFormData.bonusThreshold
          ? Number(convertedFormData.bonusThreshold)
          : convertedFormData.bonusThreshold == ''
          ? null
          : undefined,
      }
      delete newData.skipContractWarning
      await props.updateMission(newData)
      setIsNeedRefetchavAilabilities(true)
      // maybe fix for task https://www.pivotaltracker.com/story/show/175512420
    } catch (err) {
      console.error(err)
    } finally {
      props.dispatch(disableUIBlock())
    }
  }

  const editableFields = getEditableFields(mission.status, mission.type)

  const missionIdToShowDistance = mission.id

  const isNeedToCheckWarning = useMemo(
    () =>
      [MISSION_STATUS_ENUM.DRAFT, MISSION_STATUS_ENUM.AVAILABLE].includes(
        mission.status,
      ),
    [mission.status],
  )

  useEffect(() => {
    if (
      mission.userId &&
      availabilities &&
      isGermany &&
      isFirstRender &&
      isNeedToCheckWarning
    ) {
      setIsFirstRender(false)
      handlingErrorContractAvailabilitiesPopup({
        userId: mission.userId,
        availabilities,
        mission,
        brandAmbassadors: props.brandAmbassadors,
        dispatch,
        setIsContractWarningSkipped,
        setContractWarning,
      })
    }
  }, [mission.userId, availabilities, isFirstRender, isNeedToCheckWarning])

  useEffect(() => {
    const check = contractWarning && !isContractWarningSkipped

    setIsSubmitButtonDisabled(prev => prev && check && !payoutRatioError)
  }, [contractWarning, payoutRatioError])

  useEffect(() => {
    if (
      isDataChanged &&
      isGermany &&
      availabilities &&
      dataForWarningFromForm.userId &&
      isLoadedAvailabilities &&
      [
        MISSION_STATUS_ENUM.DRAFT,
        MISSION_STATUS_ENUM.AVAILABLE,
        MISSION_STATUS_ENUM.BOOKED,
      ].includes(mission.status)
    ) {
      setIsDataChanged(false)
      setIsLoadedAvailabilities(true)

      handlingErrorContractAvailabilitiesPopup({
        userId: dataForWarningFromForm.userId,
        availabilities,
        mission: { ...mission, dateTime: dataForWarningFromForm.dateTime },
        brandAmbassadors: props.brandAmbassadors,
        dispatch,
        setIsContractWarningSkipped,
        setContractWarning,
      })
    }
  }, [
    isDataChanged,
    mission,
    availabilities,
    isLoadedAvailabilities,
    dataForWarningFromForm.userId,
    dataForWarningFromForm.dateTime,
  ])

  const callbackBrandAmbassadors = data => {
    setAvailabilities(data)
    setIsNeedRefetchavAilabilities(false)
  }

  const brandAmbassadorsSelectCache = useMemo(() => {
    let filteredAmbassadors = props.brandAmbassadors.filter(
      item => item.status == BRAND_AMBASSADOR_STATUS_ENUM.ACTIVE,
    )

    const isMissionInGroup = city.teamLeaderEnabled && mission.teamLeaderGroupId

    if (
      (isMissionInGroup && !mission.teamLeaderId) ||
      (mission.userId && mission.teamLeaderId == mission.userId)
    ) {
      filteredAmbassadors = filteredAmbassadors.filter(item => {
        return item.isTeamLeader
      })
    } else if (isMissionInGroup && mission.teamLeaderId && !mission.userId) {
      filteredAmbassadors = filteredAmbassadors.filter(item => {
        return item.id != mission.teamLeaderId
      })
    }

    return (
      <SelectDashboard
        name="userId"
        options={filteredAmbassadors.map(c => {
          const isNeedToAddPrefix = c.isTeamLeader && city.teamLeaderEnabled
          return {
            label: isNeedToAddPrefix ? `[TLA] ${c.name}` : c.name,
            value: c.id,
          }
        })}
        input={{
          value: mission.userId,
        }}
        cypress_id="BA-drop-down-input"
      />
    )
  }, [
    props.brandAmbassadors,
    mission.userId,
    mission.teamLeaderId,
    mission.teamLeaderGroupId,
    mission.status,
  ])

  const missionMapCache = useMemo(
    () => (
      <MissionMap
        mission={{
          ...mission,
          location,
        }}
        shouldShowCurrentPosition={shouldShowCurrentPosition}
      />
    ),
    [mission, location, shouldShowCurrentPosition, mission.activities],
  )

  const replaceComma = value => value.replace(',', '.')

  const validatePayoutRatio = payoutRatio => {
    if (
      payoutRatio &&
      !['0', '0.', '0.0', '0.00', '0,', '0,0', '0,00'].includes(payoutRatio)
    ) {
      const value = replaceComma(payoutRatio)

      if (Number(value)) {
        if (value >= 0 && value <= 2) {
          if (value.length > 4) {
            setPayoutRatioError(
              'Value must contain only 2 numbers after the decimal point',
            )
          } else {
            setPayoutRatioError('')
          }
        } else {
          setPayoutRatioError('Only values between 0.00 and 2.00 are accepted.')
        }
      } else {
        setPayoutRatioError('Only decimal values are accepted.')
      }
    } else {
      setPayoutRatioError('')
    }
  }

  const handleFormUpdate = (form, formState) => {
    if (formState.payoutRatio) {
      validatePayoutRatio(formState.payoutRatio.value)
    }
    if (form.name === 'userId' && form.value) {
      setDataForWarningFromForm(prev => ({ ...prev, userId: form.value }))
      setIsDataChanged(true)
    } else if (form.name === 'dateTime' && form.value) {
      if (form.value !== dataForWarningFromForm.dateTime) {
        setDataForWarningFromForm(prev => ({ ...prev, dateTime: form.value }))
        setIsDataChanged(true)
      }
    }

    if (form.name === 'dateTime' && form.value !== mission.dateTime) {
      const newWeek = moment(form.value).isoWeek()
      setWeek(newWeek)
      if (week !== newWeek) {
        setIsLoadedAvailabilities(false)
      }
    }

    const missionAvailableTimestamp = convertTimeToTimestamp(mission.dateTime)
    const missionCheckInTimestamp = convertTimeToTimestamp(mission.checkInTime)
    const checkInTimeFormValue =
      (formState.checkInTime && formState.checkInTime.value) || null
    const checkOutTimeFormValue =
      (formState.checkoutTime && formState.checkoutTime.value) || null
    if (
      (checkInTimeFormValue && checkOutTimeFormValue) ||
      (missionCheckInTimestamp && checkOutTimeFormValue)
    ) {
      const checkInTimeStamp = checkInTimeFormValue
        ? getTimestampAndSetTime({
            missionDateTime: mission.checkInTime,
            hoursStr: checkInTimeFormValue,
          })
        : missionCheckInTimestamp

      const checkInTimeAfter =
        mission.type === 'HANDTOHAND'
          ? city.h2hCheckInTimeAfter
          : city.d2dCheckInTimeAfter

      const addMinutes = checkInTimeAfter || 0

      const maxCheckinTime = moment(missionAvailableTimestamp).add(
        addMinutes,
        'minutes',
      )

      const checkoutTimeStamp = checkOutTimeFormValue
        ? getTimestampAndSetTime({
            missionDateTime: mission.checkInTime,
            hoursStr: checkOutTimeFormValue,
          })
        : +maxCheckinTime

      setIsValidCheckInOutTime(checkInTimeStamp < checkoutTimeStamp)
    }

    setIsSubmitButtonDisabled(
      !isValidCheckInOutTime ||
        !form.isValid ||
        payoutRatioError ||
        (formState.skipContractWarning
          ? !formState.skipContractWarning.value
          : false),
    )

    const isNeedToShowPopupForUpdateGroupedMissions =
      mission.city.teamLeaderEnabled &&
      mission.teamLeaderGroupId &&
      formState.dateTime &&
      formState.locationId

    if (mission.canBeSpied && !isNeedToShowPopupForUpdateGroupedMissions) {
      if (
        formState.dateTime &&
        formState.dateTime.value !== mission.dateTime &&
        !warningShow.date
      ) {
        warningShow = { ...warningShow, date: true }
        setTimeout(() => {
          dispatch(
            showReduxModal({
              title: 'Warning',
              children:
                'The mission would be removed from the spy shift if you change date',
              confirmLabel: 'OK',
              hideCancel: true,
            }),
          )
        }, 300)
      }

      if (
        formState.locationId &&
        formState.locationId.value !== props.location.id &&
        !warningShow.location
      ) {
        warningShow = { ...warningShow, location: true }

        setTimeout(() => {
          dispatch(
            showReduxModal({
              title: 'Warning',
              children:
                'The mission would be removed from the spy shift if you change location',
              confirmLabel: 'OK',
              hideCancel: true,
            }),
          )
        }, 300)
      }
    }

    if (isNeedToShowPopupForUpdateGroupedMissions) {
      if (
        formState.dateTime.value !== mission.dateTime &&
        !warningShow.groupDate
      ) {
        setTimeout(() => {
          warningShow = { ...warningShow, groupDate: true }
          dispatch(
            showReduxModal({
              title: 'Warning Date Changed',
              children: `This mission is part of a group-${
                mission.teamLeaderGroupId
              } of missions with the same location, date, and city plan.`,
              confirmLabel: 'OK',
              hideCancel: true,
            }),
          )
        }, 300)
      }

      if (
        formState.locationId.value !== mission.locationId &&
        !warningShow.groupLocation
      ) {
        setTimeout(() => {
          warningShow = { ...warningShow, groupLocation: true }
          dispatch(
            showReduxModal({
              title: 'Warning Location Changed',
              children: `This mission is part of a group-${
                mission.teamLeaderGroupId
              } of missions with the same location, date, and city plan.`,
              confirmLabel: 'OK',
              hideCancel: true,
            }),
          )
        }, 300)
      }
    }
  }

  const isCityManagerAssistant = authorization.isCityManagerAssistant()

  const isNeedToShowPayAdjustment =
    !mission.costPerFlyer && !isCityManagerAssistant

  const isNeedToShowBonusPerConversion =
    primaryMetric &&
    campaign.bonusEnabled &&
    campaign.type !== CAMPAIGN_ENUM_TYPES.DIRECTMAIL &&
    !isCityManagerAssistant

  const isNeedToShowBonusThreshold =
    campaign.bonusEnabled && canSeeBonusThreshold && !isCityManagerAssistant

  function getBrandAmbassadorName() {
    const byId = props.brandAmbassadors.find(ba => ba.id == mission.userId)
    if (byId) {
      return byId.name
    }
    return ''
  }

  return (
    <Fragment>
      <Form onUpdate={handleFormUpdate} onSubmit={updateMission}>
        <Section
          title={
            <Box display={'flex'} gap="20px">
              Mission Details
              {showNoShowBadge && <NoShowBadge />}
            </Box>
          }
        >
          <SectionRow>
            <Col xs={4}>
              <SectionLabel>Date</SectionLabel>
              {editableFields.includes('dateTime') ? (
                <DateTimePicker
                  name="dateTime"
                  initValue={mission.dateTime}
                  input={{
                    value: mission.dateTime,
                  }}
                  cypress_id="edit-mission-details-date-time-input"
                />
              ) : (
                <span cypress_id="edit-mission-details-date-time-value">
                  {formatToLocalDate(new Date(mission.dateTime))}
                </span>
              )}
            </Col>
            <Col xs={4}>
              <SectionLabel>Pack Size</SectionLabel>
              <span cypress_id="edit-mission-details-pack-size-value">
                {mission.packSize}
              </span>
            </Col>
            <Col xs={4}>
              <SectionLabel>Flyers Distributed</SectionLabel>
              {editableFields.includes('checkoutFlyerQuantity') ? (
                <Input
                  value={mission.totalFlyersDistributed}
                  initValue={mission.totalFlyersDistributed}
                  name="checkoutFlyerQuantity"
                  validator={[number]}
                  cypress_id="edit-mission-details-flyers-distributed-input"
                />
              ) : (
                <span cypress_id="edit-mission-details-flyers-distributed-value">
                  {mission.checkoutFlyerQuantity}
                </span>
              )}
            </Col>
          </SectionRow>
          <SectionRow>
            <Col xs={4}>
              <SectionLabel>Flyer Code</SectionLabel>
              {props.flyerCodes.length == 0 ? (
                <span
                  style={{ lineHeight: '50px', opacity: 0.8 }}
                  cypress_id="edit-mission-details-no-available-flyer-codes-text"
                >
                  No available codes
                </span>
              ) : editableFields.includes('flyerInventoryId') ? (
                <SelectDashboard
                  options={props.flyerCodes.map(c => ({
                    label: c.code,
                    value: c.id,
                  }))}
                  input={{
                    value: mission.flyerInventoryId,
                  }}
                  initValue={mission.flyerInventoryId}
                  name="flyerInventoryId"
                  cypress_id="edit-mission-details-flyer-code-dropdown"
                />
              ) : (
                <span cypress_id="edit-mission-details-flyer-code-value">
                  {mission.flyerInventoryId
                    ? props.flyerCodes.find(
                        f => f.id == mission.flyerInventoryId,
                      ).code
                    : '-'}
                </span>
              )}
            </Col>
            <Col xs={4}>
              <SectionLabel>Location</SectionLabel>
              {!mission.locationId ? (
                <span>-</span>
              ) : editableFields.includes('locationId') ? (
                <SelectDashboard
                  options={locations.map(c => ({
                    label: c.name,
                    value: c.id,
                  }))}
                  onChange={(e, k, v) => {
                    return setLocation(locations.find(l => l.id == v))
                  }}
                  input={{
                    value: mission.locationId,
                  }}
                  initValue={mission.locationId}
                  name="locationId"
                  cypress_id="edit-mission-details-locations-dropdown"
                />
              ) : (
                <span cypress_id="edit-mission-details-locations-value">
                  {locations.find(l => l.id == mission.locationId).name}
                </span>
              )}
            </Col>
            <Col xs={4}>
              <SectionLabel>Ambassador</SectionLabel>
              {editableFields.includes('userId') ? (
                brandAmbassadorsSelectCache
              ) : (
                <span cypress_id="edit-mission-details-brand-ambassador-value">
                  {getBrandAmbassadorName()}
                </span>
              )}
            </Col>
          </SectionRow>
          <SectionRow>
            <Col xs={12}>
              <SectionLabel>Comment</SectionLabel>
              {editableFields.includes('comments') ? (
                <Textarea
                  name="comments"
                  initValue={mission.comments}
                  meta={{}}
                  cypress_id="edit-mission-details-comment-textarea"
                />
              ) : (
                <span cypress_id="edit-mission-details-comment-value">
                  {mission.comments}
                </span>
              )}
            </Col>
          </SectionRow>
          <SectionRow>
            <Col xs={4}>
              <SectionLabel>Pay ratio (multiplier)</SectionLabel>
              {editableFields.includes('payoutRatio') ? (
                <Fragment>
                  <Input
                    name="payoutRatio"
                    value={mission.payoutRatio}
                    initValue={mission.payoutRatio}
                    cypress_id="edit-mission-details-pay-ratio-input"
                    onChange={e =>
                      setHasPayoutRatioValue(
                        e.target.value !== '' ? true : false,
                      )
                    }
                  />
                  {payoutRatioError ? (
                    <div
                      style={{
                        color: 'red',
                        margin: '8px 0 0 10px',
                        fontSize: 12,
                      }}
                    >
                      {payoutRatioError}
                    </div>
                  ) : null}
                </Fragment>
              ) : (
                <span cypress_id="edit-mission-details-pay-ratio-value">
                  {mission.payRatio}
                </span>
              )}
            </Col>
            <Col xs={8}>
              <SectionLabel>
                Pay ratio reason {hasPayoutRatioValue ? '*' : ''}
              </SectionLabel>
              {editableFields.includes('payoutRatioComment') ? (
                <Textarea
                  name="payoutRatioComment"
                  initValue={mission.payoutRatioComment}
                  meta={{}}
                  validator={
                    hasPayoutRatioValue
                      ? [
                          required,
                          minValue(
                            20,
                            'Comment must be at least 20 characters long.',
                          ),
                          maxValue(
                            200,
                            'Comment cannot exceed 200 characters.',
                          ),
                        ]
                      : undefined
                  }
                  cypress_id="edit-mission-details-pay-ratio-reason-input"
                />
              ) : (
                <span cypress_id="edit-mission-details-pay-ratio-reason-value">
                  {mission.payoutRatioComment}
                </span>
              )}
            </Col>
          </SectionRow>
          {mission.type === MISSION_ENUM_TYPES.LETTERBOX && (
            <SectionRow>
              <Col xs={4}>
                <SectionLabel>Addresses</SectionLabel>
                <span>{formatFieldValue(mission.householdsAmount)}</span>
              </Col>
              <Col xs={4}>
                <SectionLabel>Density</SectionLabel>
                <span>{formatFieldValue(mission.density)}</span>
              </Col>
            </SectionRow>
          )}
          <SectionRow>
            {isNeedToShowPayAdjustment ? (
              <Col xs={4}>
                <SectionLabel>Pay adjustment ({currencySign})</SectionLabel>
                {editableFields.includes('draftPayAdjustment') ? (
                  <Input
                    name="draftPayAdjustment"
                    value={mission.draftPayAdjustment / 100}
                    initValue={mission.draftPayAdjustment / 100}
                    validator={[number]}
                    cypress_id="edit-mission-details-pay-adjustment-input"
                  />
                ) : (
                  <span cypress_id="edit-mission-details-pay-adjustment-value">
                    {mission.draftPayAdjustment / 100}
                  </span>
                )}
              </Col>
            ) : null}
            {isNeedToShowBonusPerConversion ? (
              <Col xs={4}>
                <SectionLabel>
                  Bonus per{' '}
                  {primaryMetric.name == 'Other'
                    ? primaryMetric.label
                    : primaryMetric.name}{' '}
                  ({currencySign})
                </SectionLabel>
                {editableFields.includes('bonusOnConversion') && isAdmin ? (
                  <Input
                    name="bonusOnConversion"
                    value={mission.bonusPerConversion / 100}
                    initValue={mission.bonusPerConversion / 100}
                    validator={[number, zeroRequired, betweenNumbers(0, 50)]}
                    cypress_id="edit-mission-details-bonus-on-conversion-input"
                  />
                ) : (
                  <span cypress_id="edit-mission-details-bonus-on-conversion-value">
                    {mission.bonusPerConversion / 100}
                  </span>
                )}
              </Col>
            ) : null}
            {isNeedToShowBonusThreshold ? (
              <Col xs={4}>
                <SectionLabel>Bonus threshold(%)</SectionLabel>
                {editableFields.includes('bonusThreshold') && isAdmin ? (
                  <Input
                    name="bonusThreshold"
                    value={mission.bonusThreshold}
                    initValue={mission.bonusThreshold}
                    validator={[number, betweenNumbers(0, 100)]}
                    cypress_id="edit-mission-details-bonus-threshold-input"
                  />
                ) : (
                  <span cypress_id="edit-mission-details-bonus-threshold-value">
                    {mission.bonusThreshold || '-'}
                  </span>
                )}
              </Col>
            ) : null}
          </SectionRow>
          <SectionRow>
            <Col xs={12}>{mission.id && missionMapCache}</Col>
          </SectionRow>
        </Section>
        {mission.userId && (
          <Fragment>
            <Section title={'Brand Ambassador'}>
              <SectionRow>
                <Col xs={3}>
                  <ProfilePicture src={user.profilePicture} />
                </Col>
                <Col xs={9}>
                  <Box pb={2} cypress_id="ba-name-in-brand-ambassador-section">
                    <SectionLabel>Name</SectionLabel>
                    {getBAName({
                      firstName: user.firstName,
                      lastName: user.lastName,
                      isTeamLeader: user.isTeamLeader,
                    })}
                  </Box>

                  <Box
                    pb={2}
                    cypress_id="edit-mission-details-checkin-time-div"
                  >
                    <SectionLabel>CheckIn Time</SectionLabel>
                    {editableFields.includes('checkInTime') ? (
                      <div
                        style={
                          !isValidCheckInOutTime
                            ? { borderBottom: '1px solid red' }
                            : {}
                        }
                      >
                        <ConfirmableTimePicker
                          name="checkInTime"
                          pickerName="Check In Time"
                          value={
                            mission.checkInTime
                              ? mission.checkInTime.slice(11, 16)
                              : undefined
                          }
                          minutesStep={1}
                          cypress_id="edit-mission-details-checkin-time-value"
                        />
                      </div>
                    ) : (
                      <span cypress_id="edit-mission-details-checkin-time-span">
                        {mission.checkInTime
                          ? mission.checkInTime.slice(11, 16)
                          : '-'}
                      </span>
                    )}
                    {!isValidCheckInOutTime ? (
                      <span
                        style={{
                          color: 'red',
                          marginTop: '4px',
                          display: 'block',
                        }}
                      >
                        Check In Time time should be less then Checkout Time or
                        allowed time after mission start time
                      </span>
                    ) : null}
                  </Box>

                  <Box
                    pb={2}
                    cypress_id="edit-mission-details-checkout-time-div"
                  >
                    <SectionLabel>Checkout Time</SectionLabel>
                    {editableFields.includes('checkoutTime') ? (
                      <div
                        style={
                          !isValidCheckInOutTime
                            ? { borderBottom: '1px solid red' }
                            : {}
                        }
                      >
                        <ConfirmableTimePicker
                          name="checkoutTime"
                          pickerName="Checkout Time"
                          value={
                            mission.checkoutTime
                              ? mission.checkoutTime.slice(11, 16)
                              : undefined
                          }
                          minutesStep={1}
                          cypress_id="edit-mission-details-checkout-time-value"
                        />
                      </div>
                    ) : (
                      <span>
                        {mission.checkoutTime
                          ? mission.checkoutTime.slice(11, 16)
                          : '-'}
                      </span>
                    )}
                    {!isValidCheckInOutTime ? (
                      <span
                        style={{
                          color: 'red',
                          marginTop: '4px',
                          display: 'block',
                        }}
                      >
                        Checkout Time time should be greater then Check In Time
                      </span>
                    ) : null}
                  </Box>

                  <Box pb={2} cypress_id="edit-mission-details-pay-adjust-div">
                    <SectionLabel>Pay Adjustment</SectionLabel>
                    {mission.payoutRatio !== null
                      ? `(${
                          mission.payoutRatio
                        }) Reason: ${mission.payoutRatioComment || ' -'}`
                      : '-'}
                  </Box>

                  {isEmployeeOrSpy && props.onNotifyMissionWasSpied && (
                    <Box pb={2}>
                      {mission.notifiedSuccessfullySpied ? (
                        'Notified successfully spied ✅'
                      ) : (
                        <Button
                          variant="contained"
                          onClick={props.onNotifyMissionWasSpied}
                          //disabled={isLoading} TODO
                        >
                          Notify successfully spied
                        </Button>
                      )}
                    </Box>
                  )}
                </Col>
              </SectionRow>
            </Section>
          </Fragment>
        )}
        {isGermany && week ? (
          <Availabilities
            week={week}
            cityId={city.id}
            missionIdToShowDistance={missionIdToShowDistance}
            callbackBrandAmbassadors={callbackBrandAmbassadors}
            isLoadedCallback={setIsLoadedAvailabilities}
            isNeedRefetch={isNeedRefetchavAilabilities}
            cityCheckInTimes={{
              afternoonCheckInTime: city.afternoonCheckInTime,
              morningCheckInTime: city.morningCheckInTime,
              lunchCheckInTime: city.lunchCheckInTime,
            }}
          />
        ) : null}
        {contractWarning ? (
          <Box pb={5} display="flex" justifyContent="flex-end">
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
              }}
            >
              <div style={{ color: 'red', marginBottom: '6px' }}>
                {contractWarning}
              </div>
              <Checkbox
                input={{
                  value: isContractWarningSkipped,
                  onClick: () =>
                    setIsContractWarningSkipped(!isContractWarningSkipped),
                }}
                label={`Skip Contract Warning?`}
                name="skipContractWarning"
              />
            </div>
          </Box>
        ) : null}
        <Box pb={5} display="flex" justifyContent="space-between">
          <FormButton
            value="Cancel"
            onClick={handleCancel}
            cypress_id="edit-mission-details-cancel-button"
          />
          <SubmitButton
            disabled={
              isSubmitButtonDisabled || (isGermany && !isLoadedAvailabilities)
            }
            value="Save"
            cypress_id="edit-mission-details-submit-button"
          />
        </Box>
      </Form>
    </Fragment>
  )
}

const MissionLoadingWrapper = ({ missionDataLoaded, ...otherProps }) =>
  missionDataLoaded ? (
    <EditMissionDetailsInner {...otherProps} />
  ) : (
    'Loading mission...'
  )

export default connect()(MissionLoadingWrapper)
